export const useInIFrame = (): boolean => {
  try {
    return window.self !== window.top;
  } catch (e) {
    return true;
  }
};
